/* eslint-disable eqeqeq */
import { ListView } from 'antd-mobile';
import { StickyContainer, Sticky } from 'react-sticky';
import React,{ Component } from 'react';
import { connect } from 'dva';

let pageIndex = 0;
const NUM_SECTIONS = 3;
let dataBlobs ={}; //它是一种数据结构，包含ListView所需的所有数据（section header 和 rows），如下图:
let sectionIDs = [];  //sectionIDs 用于标识每组section
let rowIDs = [];  // rowIDs 用于描述每个 section 里的每行数据的位置及是否需要渲染。在ListView渲染时，会先遍历 rowIDs 获取到对应的 dataBlob 数据。
let AAF001 = 0;
class Order extends Component{
    constructor(props){
        super(props);

        let getSectionData = (dataBlob, sectionID) => {
          return dataBlob[sectionID];
      };

      let getRowData = (dataBlob, sectionID, rowID) => {
          return dataBlob[sectionID + ':' + rowID];
      };
      let getSectionHeaderData = (dataBlob, sectionID) => dataBlob[sectionID];

        const dataSource = new ListView.DataSource({
          getSectionData: getSectionData, // 获取组中数据
          getRowData: getRowData, // 获取行中的数据
          getSectionHeaderData,
          rowHasChanged: (row1, row2) => row1 !== row2,
          sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
        });
    
        this.state = {
          dataSource,
          isLoading: true,
          
          hasMore: true,
          pageIndex :0,
          img: 'http://hadeling.com/IMG/xlcrk/20190616111108.jpg'
        };
    }

    genData(pIndex =0){
     
      let {hasMore} =this.state;
      this.props.dispatch({type:"order/getOrder",payload:{
        AAA001 : localStorage.getItem("AAA001"),
        AAF002 : localStorage.getItem("AAC002"),
        AAF001 
      }}).then(()=>{
      
      let jsonData = this.props.orders;

      if(jsonData.length >0)
      {
        hasMore=true;
      }else{
        hasMore=false;
      }
      
      let order = [];
      for (var i in jsonData) {
          //step 1、把组数据放入sectionIDs数组中
          const ii = (pIndex * NUM_SECTIONS) + Number(i);
          sectionIDs.push(ii);
          //step 2、把组中内容放dataBlob对象中
          dataBlobs[ii] = {...jsonData[i]}

          //step 3、取出该组中所有的车
          order = jsonData[i].orderDetail;
          
          //获取最少的Id
          if(Number(AAF001)===0)
          {
            AAF001 = jsonData[i].AAF001;
          }else if(Number(jsonData[i].AAF001)< Number(AAF001)){
              AAF001 = jsonData[i].AAF001;
          }
          
          //step 4记录每一行中的数据
          rowIDs[ii] = [];
          //step 5、获取行中每一组数据
          for (var j in order) {
              //把行号放入rowIDs中
              rowIDs[ii].push(j);
              //把每一行中的内容放dataBlob对象中
              dataBlobs[ii + ':' + j] = order[j];
          }
      }
      sectionIDs = [...sectionIDs];
      rowIDs = [...rowIDs];
      this.setState({
        dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
        hasMore
      });

      });
      
    }
    componentDidMount() {
      pageIndex = 0;
      dataBlobs ={}; //它是一种数据结构，包含ListView所需的所有数据（section header 和 rows），如下图:
      sectionIDs = [];  //sectionIDs 用于标识每组section
      rowIDs = [];  // rowIDs 用于描述每个 section 里的每行数据的位置及是否需要渲染。在ListView渲染时，会先遍历 rowIDs 获取到对应的 dataBlob 数据。
      AAF001 = 0;
      if(Number(AAF001)===0)
      {
        this.genData();
      }
      
        
      }
     
      //行显示
      renderRow=(rowData, sectionID, rowID)=>
      {
        return (
          <div key={rowID} style={{ padding: '0 15px' }}>
            <div
              style={{
                lineHeight: '30px',
                color: '#888',
                fontSize: 12,
                borderBottom: '1px solid #F6F6F6',
              }}
            >{ `规格: ${rowData.AAD004}  单位:${rowData.AAD005}` }</div>
            <div style={{ display: '-webkit-box', padding: '5px 0' }}>
            {/* <img style={{ height: '64px', marginRight: '15px' }} src={this.state.img} alt="" />*/}
              
              <div style={{ lineHeight: 1 }}>
                <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>{rowData.AAD003}</div>
                <div><span style={{ fontSize: '20px', color: '#FF6E27' }}>{rowData.AAD007}</span>¥ {`x ${rowData.AAD006} = ${rowData.AAD008}`}</div>
              </div>
            </div>
          </div>
        );
      }
      
      //标题吸顶
      renderSectionHeader(sectionData){
        return(
          <Sticky>
           {({
            style,
            }) => (
            <div
                className="sticky"
                  style={{
                  ...style,
                    zIndex: 4,
                     height:30,
                     backgroundColor: sectionData.AAF015!="5" ? '#5890ff' : 'red',
                    color: 'white',
                    }}
                >{`${sectionData.AAF008} 总金额:${sectionData.AAF013}   `}{sectionData.AAF015=="5" ? '已结算':'未结算'}</div>
                )}
                </Sticky>
                )
      }
      //间距
      renderSeparator(sectionID,rowID){
        return (
          <div
            key={`${sectionID}-${rowID}`}
            style={{
              backgroundColor: '#F5F5F9',
              height: 2,
              borderTop: '1px solid #ECECED',
              borderBottom: '1px solid #ECECED',
            }}
          />
        );
      }
      renderSectionWrapper(sectionID)
      {
        return (<StickyContainer
          key={`s_${sectionID}_c`}
          className="sticky-container"
          style={{ zIndex: 4 }}
        />);
      }
      //使用this 只能用=>箭头函数
      onEndReached =(event)=> {

        
        if (this.props.isLoading ) {
          return;
        }
        if(this.state.hasMore==false)
        {
          return;
        }
        this.genData(++pageIndex);
        

      }
      renderFooter=()=>{
        return (
          <div style={{ padding: 30, textAlign: 'center' }}>{ this.state.hasMore?(this.props.isLoading ? '请稍等正在加载...' : '加载完成'):'亲掉头吧...没有数据了'}</div>
        );
      }
      renderHeader(){
        return (<span>送货单</span>);
      }
      onScroll(){

      }
      render() {
        return (
          <ListView
            ref={el => this.lv = el}
            dataSource={this.state.dataSource}
            className="am-list sticky-list"
            useBodyScroll
            renderSectionWrapper={this.renderSectionWrapper}
            renderSectionHeader={this.renderSectionHeader}
            renderHeader={this.renderHeader}
            renderFooter={this.renderFooter}
            renderRow={this.renderRow}
            renderSeparator={this.renderSeparator}
            pageSize={5}
            onScroll={this.onScroll}
            scrollEventThrottle={200}
            onEndReached={this.onEndReached}
            onEndReachedThreshold={10}
          />
        );
      }
        
}

export default connect(state=>{
  return{
    ...state.order,
    isLoading: state.loading.global
  }
})(Order)  ;